"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFieldValues = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var getListFieldValues = function getListFieldValues(items) {
  return items.reduce(function (acc, item) {
    var itemValues = getFieldValues(item);
    acc.push(itemValues);
    return acc;
  }, []);
};

var getFieldValues = function getFieldValues(fieldData) {
  return Object.entries(fieldData).reduce(function (acc, _ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    var value;

    if (v.props) {
      if (v.props.items) {
        value = getListFieldValues(v.props.items);
      } else {
        value = v.props.value;
      }
    } else {
      if (v.items) {
        value = getListFieldValues(v.items);
      } else {
        value = v.value;
      }
    }

    acc[k] = value;
    return acc;
  }, {});
};

exports.getFieldValues = getFieldValues;